<template>
  <el-card shadow="never" class="hover:shadow-sm h-full transition-shadow">
    <div class="flex h-full flex-col justify-between">
      <!-- Header row -->
      <div class="flex items-center justify-between">
        <TextMultiline
          :text="title"
          tag="h3"
          class="text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400" />

        <div
          v-if="icon"
          class="bg-blue-100 dark:bg-blue-900/30 flex h-8 w-8 items-center justify-center rounded-lg">
          <component
            :is="icon"
            class="text-blue-600 dark:text-blue-400 h-4 w-4" />
        </div>
      </div>
      <!-- Value row -->
      <div class="mt-3">
        <SmSkeleton v-if="loading" height="36px" width="70%" />
        <div v-else class="flex items-baseline gap-2">
          <span
            class="text-3xl font-bold tracking-tight text-gray-900 dark:text-white">
            {{ value }}
          </span>
          <span
            v-if="suffix"
            class="text-sm text-gray-500 dark:text-gray-400"
            >{{ suffix }}</span
          >
        </div>
      </div>
    </div>
  </el-card>
</template>

<script setup lang="ts">
  import { type Component } from 'vue'

  defineProps<{
    title: string
    value: string | number
    icon?: Component
    loading?: boolean
    suffix?: string
  }>()
</script>
